import { initI18n, type Resource } from '@kts/i18n';
import { LOCALES, type Locale } from '@kts/shared';

/**
 * Veb-ilova lug'atlari.
 *
 * `src/locales/<til>/<modul>.json` fayllari AVTOMATIK topiladi — yangi modul tarjimasini
 * qo'shish uchun shunchaki fayl yaratiladi, bu yerga hech narsa yozish shart emas.
 * Fayl nomi — nom maydoni (namespace): `orders.json` → `useT('orders')`.
 *
 * Tarjima topilmasa o'zbekchasi ko'rsatiladi (`fallbackLng: 'uz'`), shuning uchun
 * modullar bosqichma-bosqich tarjima qilinsa ham interfeys buzilmaydi.
 */
const files = import.meta.glob('./locales/*/*.json', { eager: true, import: 'default' }) as Record<
  string,
  Record<string, unknown>
>;

function buildResources(): Resource {
  const out: Resource = {};
  for (const [path, dict] of Object.entries(files)) {
    const m = /\.\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
    if (!m) continue;
    const [, locale, ns] = m as unknown as [string, Locale, string];
    if (!(LOCALES as readonly string[]).includes(locale)) continue;
    out[locale] ??= {};
    (out[locale] as Record<string, unknown>)[ns] = dict;
  }
  return out;
}

export function setupI18n() {
  return initI18n(buildResources());
}
